"use client"

import { Typography, Button, Stack, Paper } from "@mui/material"
import { ArrowBack } from "@mui/icons-material"

interface TestInstructionsProps {
  onStart?: () => void
  onBack?: () => void
}

export default function TestInstructions({ name, onFinish }: TestInstructionsProps) {
  return (
    <Paper
      elevation={2}
      sx={{
        borderRadius: 2,
        p: { xs: 3, sm: 4, md: 5 },
        maxWidth: 800,
        mx: "auto",
        width: "100%",
      }}
    >
      <Stack spacing={3}>
        <Typography
          variant="h4"
          component="h1"
          align="center"
          sx={{
            color: "primary.main",
            fontWeight: 500,
            mb: 2,
          }}
        >
          {name}
        </Typography>

        <Typography variant="body1">Este test busca medir tu velocidad y comprensión lectora.</Typography>

        <Typography variant="body1">
          Te recomendamos que lo hagas en un ambiente calmado, sin distracciones y con buena iluminación.
        </Typography>

        <Typography variant="body1">
          Esta lectura la debes hacer basado en las técnicas que ya hayas empezado a usar. En las primeras semanas, no
          debes preocuparte mucho por la comprensión lectora, ya que ese es un proceso que se va a ir dando
          paulatinamente.
        </Typography>

        <Typography variant="body1">
          Cuando des clic en INICIAR se te presentará la lectura y el sistema llevará un cronómetro que medirá tu
          velocidad. Al finalzar de leer todo el texto debes dar clic en el botón TERMINAR.
        </Typography>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
          sx={{ mt: 4 }}
        >

          <Button
            variant="contained"
            onClick={onFinish}
            sx={{
              px: 4,
              py: 1.5,
              borderRadius: 2,
            }}
          >
            INICIAR
          </Button>
        </Stack>
      </Stack>
    </Paper>
  )
}

